import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function InformationCircleIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 12C1 5.9247 5.9247 1 12 1C18.0753 1 23 5.9247 23 12C23 18.0753 18.0753 23 12 23C5.9247 23 1 18.0753 1 12ZM13.1 7.6C13.1 7.30826 12.9841 7.02847 12.7778 6.82218C12.5715 6.61589 12.2917 6.5 12 6.5C11.7083 6.5 11.4285 6.61589 11.2222 6.82218C11.0159 7.02847 10.9 7.30826 10.9 7.6C10.9 7.89174 11.0159 8.17153 11.2222 8.37782C11.4285 8.58411 11.7083 8.7 12 8.7C12.2917 8.7 12.5715 8.58411 12.7778 8.37782C12.9841 8.17153 13.1 7.89174 13.1 7.6V7.6ZM12 17.5C12.2917 17.5 12.5715 17.3841 12.7778 17.1778C12.9841 16.9715 13.1 16.6917 13.1 16.4V12C13.1 11.7083 12.9841 11.4285 12.7778 11.2222C12.5715 11.0159 12.2917 10.9 12 10.9C11.7083 10.9 11.4285 11.0159 11.2222 11.2222C11.0159 11.4285 10.9 11.7083 10.9 12V16.4C10.9 16.6917 11.0159 16.9715 11.2222 17.1778C11.4285 17.3841 11.7083 17.5 12 17.5Z"
        fill={color || "#F0AD4E"}
      />
    </svg>
  );
}
